export const commonTypes = {
  SET_LOADING: 'SET_LOADING',
  SET_SUBMITTING: 'SET_SUBMITTING',
  SET_SIDEBAR: 'SET_SIDEBAR',
  SET_COLLAPSE_SIDEBAR: 'SET_COLLAPSE_SIDEBAR',
};

export type ICommonState = Readonly<{
  isLoading: boolean;
  isSubmitting: boolean;
  showSidebar: boolean;
  showNavbar: boolean;
  collapseSidebar: boolean;
}>;
